import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import serialize from 'form-serialize';
import PropTypes from 'prop-types';
import { FormSaveButtons } from './FormSaveButtons.js';
import { FieldGroup } from './FieldGroup.js';
import Form from 'react-bootstrap/Form';
import { Form as Form$1 } from './Form.js';
import { AlertMessageTypes } from '../../constants/index.js';
import { CancelConfirmModal } from '../CancelConfirmModal/index.js';
import { AlertMessage } from '../AlertMessage/component.js';

var NestedForms = /*#__PURE__*/function (_Form) {
  function NestedForms(props) {
    var _this;

    _classCallCheck(this, NestedForms);

    _this = _callSuper(this, NestedForms, [props]);

    _defineProperty(_this, "save", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(addAnother) {
        var form, obj;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                form = _this.bootstrapForm;

                if (!form.checkValidity()) {
                  _context.next = 8;
                  break;
                }

                obj = serialize(form, {
                  hash: true,
                  empty: true
                });

                _this.props.data.forEach(function (dataObject, index) {
                  Object.assign(dataObject, obj[index]);
                });

                if (!_this.props.isCreate) {
                  _this.props.updateAction(_this.props.data);
                } else {
                  _this.props.addAction(_this.props.data, addAnother);
                }

                return _context.abrupt("return", true);

              case 8:
                _this.setState({
                  errorMessage: 'Errors on the form!',
                  runValidation: true,
                  isDisabled: false
                });

                return _context.abrupt("return", false);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_this, "onKeyDown", function (e) {
      if (e.key === 'Enter' && _this.props.allowEnterKey) {
        _this.saveAndClose(e);
      }
    });

    _this.saveAndClose = _this.saveAndClose.bind(_this);
    _this.renderChildren = _this.renderChildren.bind(_this);
    _this.state = {
      errorMessages: props.errorMessages,
      isDisabled: false
    };
    return _this;
  }

  _inherits(NestedForms, _Form);

  return _createClass(NestedForms, [{
    key: "renderChildren",
    value: function renderChildren(obj, index) {
      var childrenCount = React.Children.count(this.props.children);

      if (childrenCount && obj) {
        var child = React.Children.only(this.props.children);
        return /*#__PURE__*/React.cloneElement(child, {
          id: obj.id,
          index: index,
          componentName: obj.component,
          errorMessage: this.props.errorMessages ? this.props.errorMessages.find(function (errorMsg) {
            return errorMsg.id === obj.id;
          }) : null
        });
      }
    }
  }, {
    key: "saveAndClose",
    value: function saveAndClose(e) {
      e.preventDefault();
      this.setState({
        isDisabled: true
      });
      this.save();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var saveAndClose = this.props.saveButton ? this.saveAndClose : null;
      var cancel = this.props.cancelButton ? this.onCancel : null;
      return /*#__PURE__*/React.createElement(Form, {
        ref: function ref(form) {
          return _this2.bootstrapForm = form;
        }
      }, this.props.errorMessage && /*#__PURE__*/React.createElement(AlertMessage, {
        message: this.props.errorMessage,
        messageType: AlertMessageTypes.danger,
        visible: true
      }), this.props.data.map(function (obj, index) {
        return /*#__PURE__*/React.createElement(FieldGroup, {
          className: _this2.props.fieldGroupClass,
          data: obj,
          key: obj.id,
          onKeyDown: _this2.onKeyDown,
          runValidation: _this2.state.runValidation,
          scrollContainerId: _this2.props.scrollContainerId
        }, _this2.renderChildren(obj, index));
      }), (saveAndClose || cancel) && /*#__PURE__*/React.createElement(FormSaveButtons, {
        branded: this.props.branded,
        buttonStyle: this.props.buttonStyle,
        cancel: cancel,
        className: this.props.buttonGroupClass,
        isDisabled: this.state.isDisabled,
        save: saveAndClose,
        saveButtonText: this.props.saveButtonText
      }), /*#__PURE__*/React.createElement(CancelConfirmModal, {
        branded: this.props.branded,
        show: this.state.showCancelConfirm,
        onCancelClose: this.onCancelClose
      }));
    }
  }]);
}(Form$1);

_defineProperty(NestedForms, "propTypes", {
  addAction: PropTypes.func,
  allowEnterkey: PropTypes.bool,
  branded: PropTypes.bool,
  buttonGroupClass: PropTypes.string,
  buttonStyle: PropTypes.string,
  cancelButton: PropTypes.bool,
  children: PropTypes.any,
  data: PropTypes.array.isRequired,
  errorMessage: PropTypes.string,
  errorMessages: PropTypes.array,
  fieldGroupClass: PropTypes.string,
  isCreate: PropTypes.bool,
  onCancel: PropTypes.func,
  saveButton: PropTypes.bool,
  saveButtonText: PropTypes.string,
  updateAction: PropTypes.func
});

_defineProperty(NestedForms, "defaultProps", {
  allowEnterkey: true,
  branded: false,
  saveButton: true,
  cancelButton: true,
  isCreate: true
});

NestedForms.displayName = "NestedForms";
export { NestedForms };